export const BONUSES_STATES_FILTERS = [
  { text: 'Active', value: true },
  { text: 'Not Active', value: false },
]
